// Module
var code = "<h2>{{title}}</h2> <div class=content data-ref=content></div>";
// Exports
export default code;